import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PowerPointFileIcon = (props: IconProps) => (
  <Icon width="88px" height="77px" viewBox="0 0 88 77" {...props}>
    <path d="M12.226 21.547C2.166 30.128.852 45.392 9.294 55.62c8.441 10.227 23.457 11.562 33.518 2.98 10.06-8.581 11.374-23.846 2.932-34.073-8.441-10.228-23.457-11.563-33.518-2.981Zm28.217 4.346-12.63 10.774-10.599-12.84c7.268-4.779 16.888-3.923 23.229 2.066ZM12.939 52.511c-6.225-7.54-5.801-18.542.63-25.575l24.255 29.385c-7.93 5.218-18.661 3.731-24.885-3.81Zm28.53.7L30.87 40.373 43.5 29.6c4.7 7.387 3.86 17.167-2.032 23.613Z" />
    <rect width="27.757" height="4.031" x="57.445" y="26.492" rx="2.015" />
    <rect width="27.757" height="4.031" x="57.445" y="34.554" rx="2.015" />
    <rect width="15.861" height="4.031" x="57.445" y="42.616" rx="2.016" />
  </Icon>
);

export default memo(PowerPointFileIcon);
